module.exports = { adminPath: 'https://aquadb.fr/administration/web/', appPath: 'https://aquadb.fr/', postgrestPath: 'https://aquadb.fr/postgrest/', aquasysPath: 'https://www.aquasys.fr', layerPath: 'https://aquadb.fr/layers/', aqua6boAuthPath: 'https://aqua6bo.aquadb.fr/auth/', recaptchaKey: '6LdD4ZgUAAAAAMf3IRb1qM6CO3IRQNfVWm804N7X', aquadbSupport: 'https://www.aquasys.fr/aquadb/contact/' }



// WEBPACK FOOTER //
// ./src/conf/basepath.js